import { render, staticRenderFns } from "./BuybackQuestions.vue?vue&type=template&id=270f4dab&scoped=true"
import script from "./BuybackQuestions.vue?vue&type=script&lang=js"
export * from "./BuybackQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f4dab",
  null
  
)

export default component.exports